import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import toast from 'react-hot-toast';

export const useNativeGoogleSignIn = (googleLogin) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    console.log('✅ useNativeGoogleSignIn: Hook initialized and listening for messages');

    const handleNativeGoogleSignIn = async (event) => {
      console.log('📬 useNativeGoogleSignIn: Received message event:', event.data);

      if (event.data && event.data.type === 'GOOGLE_SIGN_IN_SUCCESS') {
        const { idToken, email, name } = event.data.data;

        console.log('🎉 useNativeGoogleSignIn: Google Sign-In SUCCESS detected');
        console.log('👤 User email:', email);
        console.log('📛 User name:', name);
        console.log('🔑 ID Token length:', idToken?.length);

        try {
          console.log('🚀 useNativeGoogleSignIn: Calling googleLogin with idToken...');

          // Use the existing googleLogin function with the idToken
          const result = await googleLogin(idToken);

          console.log('📊 useNativeGoogleSignIn: googleLogin result:', result);

          if (result.success) {
            console.log('✅ useNativeGoogleSignIn: Login successful!');

            if (result.requiresTermsAcceptance) {
              toast.success('Welcome! Please accept the terms and conditions to continue.');
            } else {
              toast.success(`Welcome back, ${name || email}!`);
            }

            // Navigate to dashboard after successful login
            console.log('🧭 useNativeGoogleSignIn: Navigating to /app/dashboard...');
            console.log('📍 Current location:', location.pathname);

            // Use setTimeout to ensure state is fully updated before navigation
            setTimeout(() => {
              navigate('/app/dashboard', { replace: true });
              console.log('✅ Navigation command sent');
            }, 100);
          } else {
            console.error('❌ useNativeGoogleSignIn: Login failed:', result.error);
            toast.error(result.error || 'Google sign-in failed');
          }
        } catch (error) {
          console.error('💥 useNativeGoogleSignIn: Exception during login:', error);
          toast.error('Failed to process Google sign-in');
        }
      } else if (event.data && event.data.type === 'GOOGLE_SIGN_IN_ERROR') {
        console.error('❌ useNativeGoogleSignIn: Google Sign-In ERROR:', event.data.error);
        toast.error('Google sign-in failed: ' + (event.data.error || 'Unknown error'));
      } else {
        // Log other messages for debugging (but don't spam)
        if (event.data?.type) {
          console.log('📨 useNativeGoogleSignIn: Other message type:', event.data.type);
        }
      }
    };

    // Listen for messages from the native iOS app
    window.addEventListener('message', handleNativeGoogleSignIn);
    console.log('👂 useNativeGoogleSignIn: Event listener attached');

    // Also expose a function for the native app to call directly
    if (!window.nativeGoogleSignInHandler) {
      window.nativeGoogleSignInHandler = handleNativeGoogleSignIn;
      console.log('🔌 useNativeGoogleSignIn: Global handler exposed');
    }

    return () => {
      console.log('🧹 useNativeGoogleSignIn: Cleaning up listeners');
      window.removeEventListener('message', handleNativeGoogleSignIn);
      if (window.nativeGoogleSignInHandler) {
        delete window.nativeGoogleSignInHandler;
      }
    };
  }, [googleLogin, navigate, location]);
};